class MakeNodesInfomation {
  nodeMap;
  nodeData = [];
  nodeContents = {};
  nodeMemos = {};
  constructor(nodeData, nodeContents, nodeMemos) {
    this.nodeData = nodeData ? nodeData : this.nodeData;
    this.nodeMap = new Map();
    this.nodeContents = nodeContents ? nodeContents : this.nodeContents;
    this.nodeMemos = nodeMemos ? nodeMemos : this.nodeMemos;
  }
  set setNodesData (data) { this.nodeData = data }
  set setNodeContents (data) { 
    this.nodeContents = data || {} 
  }
  set setNodeMemos (data) { 
    this.nodeMemo = data || {} 
  }
  makeNodeList(nodes) {
    if(!nodes) nodes = this.nodeData;
    else this.nodeData = nodes;
    const list = [];
    this.nodeMap.clear();
    for(let node of nodes) {
      if(this.nodeMap.has(node.key)) {
        let before = this.nodeMap.get(node.key);
        node.child = before.child;
        before = node;
      }else {
        this.nodeMap.set(node.key, node);
      }
      if(node?.display === false ) { continue }
      if(node?.H === true ) { continue }
      if(this.nodeMap.has(node.parent)) {
        let parent = this.nodeMap.get(node.parent);
        if(!parent.child) {
          parent.child = [];
        } 
        parent.child.push( node );
      } else {
        this.nodeMap.set(node.parent, {
          child: [node],
          key : node.parent
        })
      }
    }
    let nodeEntries = this.nodeMap.values()

    function makeTree (nodes, depth=0) {
      let items = [];
      for(const node of nodes) {
        if(node.child) {
          node.child = makeTree(node.child, depth+1)
          items.push(node);
        } else {
          items.push(node);
        }
        node.depth = Math.max(node.depth || 0, depth)
      }
      return items;
    }
    for(const item of makeTree(nodeEntries)){
      if(!item.depth || item.depth === 0) {
        list.push(item)
      }
    }
    return list
  }
  async *getContents(contents) {
  try {
      for(let {text, key, protocolId, child, category, parent, isWriter, isProcess, isKeyword, memo, P, R, C, D, M, V, L, H, T, display, nodeValue } of contents) {
        if( isWriter === true || isProcess === true || isKeyword ) {
          yield false
        } else {
          let res = {}
          res.content = this.nodeContents[key] ? this.nodeContents[key] : null;
          res.memo = this.nodeMemos[key] ? this.nodeMemos[key] : null;
          res.tagKey = key;
          res.protocolId = protocolId;
          res.title = text;
          res.child = child;
          res.category = category;
          res.parent = parent;
          res.memo = memo
          res.P = P;
          res.R = R;
          res.C = C;
          res.D = D;
          res.M = M;
          res.V = V;
          res.L = L;
          res.H = H;
          res.T = T;
          res.display = display;
          res.nodeValue = nodeValue;
          yield res
        }
      }
    }catch (error) {
      return error
    }
  }
  async  makeListData(nodeData, step=0, maxStep=1000) {
    const childContents = []
    for await (const item of this.getContents(nodeData)) {
      // if( item.display === false ) continue;
      let children;
      if(item !== false) { 
        if(item.child && step < maxStep) {
          children = await this.makeListData(item.child, step+1)
        }
        childContents.push({
          key: item.tagKey,
          content: item.content,
          title: item.title,
          child: children || (item.child ? [] : false),
          protocolId: item.protocolId,
          parent: item.parent,
          category: item.category,
          memo: item.memo,
          P:item.P,
          R:item.R,
          C:item.C,
          D:item.D,
          M:item.M,
          V:item.V,
          L:item.L,
          H:item.H,
          T:item.T,
          nodeValue:item.nodeValue,
          isDisabled : item.isDisabled,
          isAnalysis : item.isAnalysis,
          visible : item.visible, // readonly 
          // memo: item.temporaryText
          step, 
        })
      }
    }
    return childContents
  }
}


export default MakeNodesInfomation;
